export const HELP_MS_URL = process.env.REACT_APP_HELP_MS_URL
export const X_API_KEY = process.env.REACT_APP_X_API_KEY
